import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { auth } from "./firebase.config";
import { createUser } from "./userService";

const googleProvider = new GoogleAuthProvider();

// Google Login
export const googleSignIn = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    return result.user;
  } catch (error) {
    console.error("Google sign-in error:", error.message);
    throw error;
  }
};

// Sign Up
export const signUp = async ({ username, email, password }) => {
  try {
    const { user } = await createUserWithEmailAndPassword(
      auth,
      email,
      password,
    );

    await createUser(user.uid, {
      email,
      username,
      role: 'normal',
      profilePic: '',
      subscriptions: [],
      createdAt: new Date(),
    });

    return user;
  } catch (error) {
    console.error(error.message);
    throw error;
  }
};

// google signup
export const googleSignUp = async () => {
  try {
    const user = await googleSignIn();

    await createUser(user.uid, {
      email: user.email,
      username: user.displayName,
      role: 'normal',
      profilePic: '',
      subscriptions: [],
      createdAt: new Date(),
    });

    return user;
  } catch (error) {
    console.error(error.message);
    throw error;
  }
};

// Login
export const login = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    return userCredential.user;
  } catch (error) {
    console.error(error.message);
    throw error;
  }
};

// Logout
export const logout = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error(error.message);
    throw error;
  }
};
